import { useEffect, useState } from "react";
import moment from "moment";
import columns from "../../../../columns/recentTransaction";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import MySegmented from "../../../../components/segmented/Segmented";

const RecentTable = ({ data }) => {
    const [type, setType] = useState("Deposit");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const transactionData = type === "Deposit" ? data?.lastfiveDeposit : data?.lastfiveWithdrawal;

        setFilteredData(transactionData?.map((item) => {
            return ({
                ...item,
                amount: `$ ${item?.amount}`,
                transactionDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
                status: <span className={`px-3 py-1 rounded-full uppercase text-xs text-center ${item?.status === "Success" ? 'success_tag' : 'fail_tag'}`}>{item?.status}</span>,
            })
        }));
    }, [type, data]);

    return (
        <div className='border-2 border-light rounded-[10px] p-5 h-full'>
            <div className="flex flex-wrap items-center justify-between sm:gap-5 gap-3">
                <h2 class="text-lg font-semibold">Recent Transactions</h2>
                <MySegmented options={["Deposit", "Withdraw"]} value={type} setValue={setType} />
            </div>

            <div className="mt-5">
                <TableWithSkeleton columns={columns} data={filteredData} />
            </div>
        </div>
    )
}

export default RecentTable;
